import React, { useEffect } from "react";
import { QRCodeSVG } from "qrcode.react";
import { useI18n } from "../i18n/I18nContext";

const MiddlewareQrModal = ({ onClose, service }) => {
    const { t } = useI18n();

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose();
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [onClose]);

    if (!service?.externalUrl) {
        return null;
    }

    const serviceName = t(`services.${service.key}.name`);

    return (
        <div className="middleware-modal-backdrop" role="presentation" onClick={onClose}>
            <section
                aria-labelledby="middleware-modal-title"
                aria-modal="true"
                className="middleware-modal"
                role="dialog"
                onClick={(event) => event.stopPropagation()}
            >
                <header className="middleware-modal-header">
                    <div>
                        <p className="docs-eyebrow">{t("middlewareQr.access")}</p>
                        <h2 id="middleware-modal-title">{serviceName}</h2>
                    </div>
                    <button
                        aria-label={t("middlewareQr.close")}
                        className="middleware-modal-close"
                        type="button"
                        onClick={onClose}
                    >
                        x
                    </button>
                </header>

                <div className="middleware-qr-content">
                    <div
                        aria-label={t("middlewareQr.imageAlt")}
                        className="middleware-qr-image"
                        role="img"
                    >
                        <QRCodeSVG
                            bgColor="#ffffff"
                            fgColor="#111827"
                            includeMargin
                            level="M"
                            size={220}
                            value={service.externalUrl}
                        />
                    </div>
                    <div className="middleware-qr-copy">
                        <p>{t("middlewareQr.instructions")}</p>
                        <code>{service.externalUrl}</code>
                        <a className="service-link" href={service.externalUrl} rel="noreferrer" target="_blank">
                            {t("middlewareQr.viewWeb")}
                        </a>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default MiddlewareQrModal;
